import { action } from 'typesafe-actions';
import { FornecedorTypes, IFornecedor } from './types';

export const loadRequest = () => action(FornecedorTypes.LOAD_REQUEST);
export const loadSuccess = (data: IFornecedor[]) => action(FornecedorTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(FornecedorTypes.LOAD_FAILURE);
